import React, { createContext, useContext, useState, useEffect, SetStateAction, Dispatch } from "react";
import { service } from "../services/AxiosServices";
interface TrainingRecord {
  id: string;
  document: any[];
  uploaded_by?: string;
  uploaded_on: string;
  created_at: string;
}
interface PhaseContextType {
  phases: Record<number, number>;
  trainingRecords: Record<number, TrainingRecord[]>;
  setTrainingRecords: Dispatch<SetStateAction<Record<number, TrainingRecord[]>>>;
  fetchTrainingRecords: (entityId: number, records: TrainingRecord[]) => void;
  fetchPhase: (crewId: number, category: string) => Promise<void>;
  getPhase: (crewId: number) => number;
  getTrainingRecords: (entityId: number) => TrainingRecord[];
  getAnalyzedRecordsCount: (entityId: number) => number;

}

const PhaseContext = createContext<PhaseContextType | undefined>(undefined);

export const usePhase = () => {
  const context = useContext(PhaseContext);
  if (!context) {
    throw new Error("usePhase must be used within a PhaseProvider");
  }
  return context;
};

export const PhaseProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Track phases for multiple crews using a Record
  const [phases, setPhases] = useState<Record<number, number>>({});
  const [trainingRecords, setTrainingRecords] = useState<Record<number, TrainingRecord[]>>([]);

  const fetchPhase = async (crewId: number, category: string) => {
    try {
      const formData = { entity_id: crewId, entity_type: category };
      const response = await service<any>("api/get-phase", "post", formData);
      const phaseValue = response?.data?.phase || 0;
      
      // Update the phases object with the new phase for this specific crewId
      setPhases(prevPhases => ({
        ...prevPhases,
        [crewId]: phaseValue
      }));
    } catch (error) {
      console.error("Error fetching phase:", error);
    }
  };

  // Helper function to get phase for a specific crewId
  const getPhase = (crewId: number): number => {
    return phases[crewId] || 0;
  };

  const fetchTrainingRecords = (entityId: number, records: TrainingRecord[]) => {
    setTrainingRecords(prevRecords => ({
      ...prevRecords,
      [entityId]: records
    }));
  };
  const getTrainingRecords = (entityId: number): TrainingRecord[] => {
    return trainingRecords[entityId] || [];
  };

  const getAnalyzedRecordsCount = (entityId: number): number => {
    return trainingRecords[entityId]?.length || 0;
  };

  return (
    <PhaseContext.Provider value={{ phases, fetchPhase, getPhase,  trainingRecords,fetchTrainingRecords,setTrainingRecords,getTrainingRecords,getAnalyzedRecordsCount}}>
      {children}
    </PhaseContext.Provider>
  );
};